import { FC } from "react";
import { CustomerEditActivityProps } from "./types";
import {
  ActivityBody,
  ActivityBodyInfo,
  ActivityBy,
  ActivityDate,
  ActivityFooter,
  ActivityTitle,
} from "../../components";
import { CustomerActivityEdit } from "../types";

const CustomerEditActivity: FC<CustomerEditActivityProps> = ({
  activity,
  type,
  by,
  date,
}) => {
  const _activity = activity as CustomerActivityEdit;
  return (
    <>
      <ActivityTitle type={type}>ویرایش مشتری</ActivityTitle>
      <ActivityBody>
        <ActivityBodyInfo
          type={type}
          title="نام مشتری"
          value={_activity.fullname}
        />
        <ActivityBodyInfo
          type={type}
          title="شماره تماس"
          value={_activity.phone}
        />
      </ActivityBody>
      <ActivityFooter>
        <ActivityBy>{by}</ActivityBy>
        <ActivityDate>{date}</ActivityDate>
      </ActivityFooter>
    </>
  );
};

export default CustomerEditActivity;
